import driverinfosecurity from '../utils/DriverInfoSecurity';
import { correlationId } from '../utils/correlationId';

export function authHeaders(): HeadersInit {
    return {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + (driverinfosecurity.getBearerTokenFromStorage() ?? ''),
        'X-Correlation-ID': correlationId
    };
}

export function authHeadersFormData(): HeadersInit {
    return {
        'Authorization': 'Bearer ' + (driverinfosecurity.getBearerTokenFromStorage() ?? ''),
        'X-Correlation-ID': correlationId
    };
}

export async function apiFetch<T>(url: string, init?: RequestInit): Promise<T> {
    const response = await fetch(url, init);
    if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    // Some endpoints return 200 with no body on DELETE
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        return response.json() as Promise<T>;
    }
    return undefined as unknown as T;
}
